module.exports = __webpack_public_path__ + "static/img/zanting_audio.7e79fad.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/AtomicChain/assets/zanting_audio.png
// module id = LZ3V
// module chunks = 3